// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Cart: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="19" viewBox="0 0 26 19">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9.42387573,15.9348727 L9.42387573,15.9348727 C9.86571876,16.3759179 9.86571876,17.0910801 9.42387573,17.5321253 L8.28506978,18.6692161 C7.84288476,19.1102613 7.12642877,19.1102613 6.68458574,18.6692161 L6.68458574,18.6692161 C6.24274271,18.228171 6.24274271,17.5130087 6.68458574,17.0716222 L7.82373367,15.9348727 C8.2655767,15.4938276 8.9820327,15.4938276 9.42387573,15.9348727 M21.264072,15.9348727 L21.264072,15.9348727 C21.705915,16.3759179 21.705915,17.0910801 21.264072,17.5321253 L20.125266,18.6692161 C19.683081,19.1102613 18.966625,19.1102613 18.524782,18.6692161 L18.524782,18.6692161 C18.082939,18.228171 18.082939,17.5130087 18.524782,17.0716222 L19.6639299,15.9348727 C20.1057729,15.4938276 20.8222289,15.4938276 21.264072,15.9348727 M0,0 L0,1.47470207 L4.69817302,1.47470207 L9.59811646,13.0309727 L23.0698831,13.0309727 L23.0698831,11.5559293 L10.576874,11.5559293 L9.46405882,8.9311644 L24.5106607,8.9311644 L24.5106607,7.45612097 L8.83857051,7.45612097 L7.72609731,4.8313561 L26,4.8313561 L26,3.35665404 L7.10060899,3.35665404 L5.67727255,0 L0,0 Z"
            />
        </svg>
    );
};

export default React.memo(Cart);
